<div class="rules table-container">
	<div class="search-container">
		<app-search-input
			[placeholder]="('search' | i18next: { format: 'capitalize' }) + '...'"
			[inputStr]="currentRuleApiParams.name || ''"
			(inputChanged)="inputChanged($event)"
		></app-search-input>
		<app-action-button
			id="delete-rules-btn"
			[disabled]="!selectedRows.length"
			title="delete"
			matIcon="delete"
			(buttonClicked)="deleteButtonClick(ruleIds)"
		></app-action-button>
	</div>
	<div class="header">
    <h2 class="heading-3">{{ "rule list" | i18next: { format: "capitalize" } }}</h2>
		<p>{{ "rules selected" | i18next: { count: selectedRows.length } }}</p>
	</div>
	<ng-container *ngIf="getDataSource().data?.length > 0; else noData">
		<app-table
			[dataSource]="getDataSource()"
			[view]="view"
			[activeRowId]="clickedRule?.id"
			activeRowIdKey="id"
			(dataCheckboxEmitter)="disableDataCheckbox($event)"
			(toolTipEmitter)="enableToolTip($event)"
			(sortChange)="onMatSortChange($event)"
			(selectedRows)="selectedRowsReceived($event)"
			(sortObjChanged)="receiveSortObj($event)"
			(rowClicked)="onRowClick($event)"
			checkboxText="SELECT RULE"
		>
			<!-- rule -->
			<app-column
				name="rule name"
				id="ruleName"
				sortable="true"
				data="name"
				view="rules"
			></app-column>
			<!-- assigned assets -->
			<app-column
				id="assigned-assets"
				name="assigned assets"
				data="assignedAssets"
				view="rules"
			></app-column>
			<!-- date updated -->
			<app-column
				id="updated"
				name="last updated"
				data="updated"
				sortable="true"
				view="rules"
			></app-column>
			<!-- user who wrote rule -->
			<app-column
				id="userName"
				name="user"
				data="byUser"
				view="rules"
			></app-column>
		</app-table>
		<app-paginator
			[length]="paginatorLength"
      [page]="currentRuleApiParams.page || '1'"
			[pageSizeOptions]="pageSizeOptions"
			(pageQueryChange)="pageQueryChange($event)"
		></app-paginator>
	</ng-container>

	<ng-template #noData>
		<p *ngIf="!error">{{ "there are no rules" | i18next }}</p>
	</ng-template>

	<p *ngIf="error">{{ "an error occurred fetching the data" | i18next }}</p>
</div>

<ng-template #ruleErrors>
	<p class="evir-font-default">
		{{ "an error occurred deleting names" | i18next: { names: failedRuleNames, interpolation: { escapeValue: false } } }}
	</p>
</ng-template>
